// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1__6i","cls2":"PostEngagementFollowPrompt-cls2_c9Z PostEngagementFollowPrompt-cls1__6i"};